var _style, _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreimg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106 107",
    style: {
      enableBackground: "new 0 0 106 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;}\r\n\t.st2{font-family:'Arial-BoldMT';}\r\n\t.st3{font-size:36px;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,0.1h86c5.5,0,10,4.5,10,10v86c0,5.5-4.5,10-10,10H10c-5.5,0-10-4.5-10-10v-86C0,4.6,4.5,0.1,10,0.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,0.1h86c5.5,0,10,4.5,10,10v86c0,5.5-4.5,10-10,10H10c-5.5,0-10-4.5-10-10v-86C0,4.6,4.5,0.1,10,0.1z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 6.9717 66.0146)",
    className: "st2 st3"
  }, "EQ18")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreimg7);
export default __webpack_public_path__ + "static/media/coreimg7.b78bbcd63d6e8eb2c5abbf4fe8157353.svg";
export { ForwardRef as ReactComponent };